import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

// 🔹 Gradient helper
const createGradient = (ctx, area, color) => {
    const gradient = ctx.createLinearGradient(0, area.bottom, 0, area.top);
    gradient.addColorStop(0, color + '55');
    gradient.addColorStop(1, color);
    return gradient;
};

export default class BarChartTemplate2 extends React.Component {
    render() {
        const {
            graphData,
            colors,
            xLabel,
            yLabel,
            layoutItem
        } = this.props;



        const reportConfig = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.reportConfig
        const { externalUrl, targetProperty } = reportConfig

        const options = {
            responsive: true,
            maintainAspectRatio: false,


            onClick: (event, elements) => {
                if (!elements.length) return;
                if (externalUrl && targetProperty) {
                    const barIndex = elements[0].index;
                    const clickedStockData = graphData[barIndex];
                  
                    let str = targetProperty.replace('{{', '').replace('}}', '');
                    const prefix = '__ADDITIONAL_MODEL_DATA.';
                    if (str.startsWith(prefix)) {
                        str = str.replace(/^__ADDITIONAL_MODEL_DATA\.[^.]+\./, '');
                    }
                    const baseUrl = window.location.origin;
                    if (clickedStockData.xProperties) {
                        const redirectUrl = `${baseUrl}/app/${externalUrl}?ct=${str}:${clickedStockData.xProperties}`
                        window.location.href = redirectUrl
                    }

                }

            },

            animation: {
                duration: 1200,
                easing: 'easeOutQuart',
            },
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rectRounded',
                        padding: 20,
                        font: { size: 12 },
                    },
                },
                tooltip: {
                    backgroundColor: '#1f2937',
                    titleColor: '#ffffff',
                    bodyColor: '#ffffff',
                    cornerRadius: 8,
                    padding: 12,
                },
                title: {
                    display: true,
                    text: yLabel,
                    font: { size: 16, weight: 'bold' },
                    padding: { bottom: 20 },
                },
            },
            scales: {
                x: {
                    grid: { display: false },
                    ticks: { font: { size: 12 } },
                    title: {
                        display: true,
                        text: xLabel,
                        font: { size: 14, weight: 'bold' },
                    },
                },
                y: {
                    grid: {
                        borderDash: [6, 6],
                        color: 'rgba(0,0,0,0.06)',
                    },
                    ticks: { font: { size: 12 } },
                    title: {
                        display: true,
                        text: yLabel,
                        font: { size: 14, weight: 'bold' },
                    },
                },
            },
        };

        let labels = [];
        let yAxisData = [];

        if (graphData && graphData.length) {
            graphData.forEach(item => {
                labels.push(item.xProperties);
                yAxisData.push(item.yProperties);
            });
        }

        const chartData = {
            labels,
            datasets: [
                {
                    label: yLabel,
                    data: yAxisData,
                    borderRadius: 12,
                    barThickness: 38,
                    hoverBackgroundColor: colors,
                    backgroundColor: (context) => {
                        const { chart } = context;
                        const { ctx, chartArea } = chart;
                        if (!chartArea) return colors;
                        return colors.map(color =>
                            createGradient(ctx, chartArea, color)
                        );
                    },
                },
            ],
        };

    
        return (
            <div
                style={{
                    height: '420px',
                    width: '100%',
                    padding: '16px',
                    background: '#ffffff',
                    borderRadius: '14px',
                }}
            >
                <Bar options={options} data={chartData} />
            </div>
        );
    }
}
